import { css } from '@emotion/core';
import { Tabs } from 'antd';
import React, { useEffect, useState } from 'react';

import Button from '@/src/shared/components/Button';
import Event from '@/src/shared/components/Event';
import { bp, colors } from '@/styles';
import { convertMomentToDate, today, yesterday } from '@/utils/dateTimeHelpers';
import searchContent from '@/utils/searchContent';
import { windowScrollTo } from '@/utils/utils';

const { TabPane } = Tabs;

const styles = {
  container: css`
    width: auto;
    margin: 0 -16px;
    height: fit-content;
    box-shadow: 0 6px 12px 0 rgba(35, 32, 32, 0.1);
    background-color: ${colors.white};
    padding: 32px 16px;
    @media ${bp.md} {
      width: 100%;
      margin: 0;
      padding: 32px;
    }
    @media ${bp.xl} {
      width: 40%;
    }
    > a {
      margin: 0 0 16px !important;
    }
  `,
  tabs: css`
    margin-bottom: 24px;
    .ant-tabs-tab {
      color: ${colors.secondaryGray};
      font-size: 1.6rem;
      line-height: 2.4rem;
      font-weight: bold;
      padding: 0 0 22px;
      &.ant-tabs-tab-active {
        color: ${colors.primaryRed};
      }
    }
    .ant-tabs-bar {
      border: none;
      margin: 0 0 4.5px 0;
    }
    .ant-tabs-ink-bar {
      height: 6px;
      background-color: ${colors.primaryRed};
    }
  `,
  header: css`
    margin-top: 32px;
    margin-bottom: 21px;
  `,
  noEvents: css`
    margin-top: 1.6rem;
  `,
};

const CommitteeMeetings = props => {
  const [upcomingMeetings, setUpcomingMeetings] = useState([]);
  const [pastMeetings, setPastMeetings] = useState([]);
  const { committees } = props;

  useEffect(() => {
    (async () => {
      try {
        if (committees.length) {
          const current = convertMomentToDate(today());
          const yesterdays = convertMomentToDate(yesterday());
          const meetingOptions = { committees, cat1Id: 9997, page: 1, pageSize: 3, date: true };
          const { results: upcoming } = await searchContent(
            {
              ...meetingOptions,
              dateStart: current,
              sortField: 'upcomingevents',
              sortOrder: 'ASC',
            },
            { cache: false }
          );
          const { results: past } = await searchContent(
            { ...meetingOptions, dateEnd: yesterdays },
            { cache: false }
          );
          setUpcomingMeetings(upcoming);
          setPastMeetings(past);
          windowScrollTo({ top: 0 });
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }, [committees]);

  if (!committees.length || (!upcomingMeetings.length && !pastMeetings.length)) {
    return null;
  }

  const committeesCodeStr = committees.map(({ CommitteeCode }) => CommitteeCode).join(',');
  const meetingsUrl = `/events/meetings?committees=${committeesCodeStr}`;

  return (
    <section css={styles.container}>
      <Tabs defaultActiveKey="1" css={styles.tabs}>
        <TabPane tab="Upcoming Meetings" key="1">
          {upcomingMeetings.length >= 1 ? (
            <>
              {upcomingMeetings.map(event => (
                <Event key={event.SitePageId} event={event} />
              ))}
            </>
          ) : (
            <p css={styles.noEvents}>You have no upcoming meetings</p>
          )}
        </TabPane>
        <TabPane tab="Past Meetings" key="2">
          {pastMeetings.length >= 1 ? (
            <>
              {pastMeetings.map(event => (
                <Event key={event.SitePageId} event={event} />
              ))}
            </>
          ) : (
            <p css={styles.noEvents}>You have no past meetings</p>
          )}
        </TabPane>
      </Tabs>
      <Button theme="default" size="small" link href={meetingsUrl}>
        View All
      </Button>
    </section>
  );
};

export default CommitteeMeetings;
